import { h, Component } from "preact";
import PropTypes from "prop-types";
import { connect } from "preact-redux";
import { ON_MOBILE_DEVICE } from "../../../../config";
import { googleLogin, googleLoginError } from "../../actions";

import { Button } from "semantic-ui-react";

import styles from "./DeviceGoogleLogin.scss";

import { signIn, loadGAuth } from "../../../../utils/google-auth";

const requestSignIn = notifyAuthChange => e => {
  e.preventDefault();
  signIn().then(notifyAuthChange);
};

export class DeviceGoogleLogin extends Component {
  constructor(props) {
    loadGAuth();

    super(props);
    this.onGoogleSignIn = this.onGoogleSignIn.bind(this);
    this.onGoogleSignInMobile = this.onGoogleSignInMobile.bind(this);
    this.onGoogleSignInError = this.onGoogleSignInError.bind(this);
  }

  onGoogleSignIn(googleAccInfo) {
    let idToken = googleAccInfo.getAuthResponse().id_token;
    this.props.googleLogin(idToken);
  }

  onGoogleSignInError(error) {
    this.props.googleLoginError(error);
  }

  onGoogleSignInMobile() {
    window.plugins.googleplus.login(
      { webClientId: process.env.GOOGLE_CLIENT_ID },
      result => {
        this.props.googleLogin(result.idToken);
      },
      error => {
        console.error(error);
        this.props.googleLoginError(JSON.stringify(error));
      }
    );
  }

  render() {
    return ON_MOBILE_DEVICE() ? (
      <Button
        className={styles.signInButton}
        onClick={this.onGoogleSignInMobile}
      >
        Login with Google
      </Button>
    ) : (
      <Button
        disabled={this.state.loadingGoogle}
        id="login"
        className={styles.signInButton}
        onClick={requestSignIn(this.onGoogleSignIn)}
      >
        Login with Google
      </Button>
    );
  }
}

DeviceGoogleLogin.PropTypes = {
  googleLogin: PropTypes.func.isRequired,
  googleLoginError: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = { googleLogin, googleLoginError };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeviceGoogleLogin);



// WEBPACK FOOTER //
// ./src/modules/login/components/deviceGoogleLogin/DeviceGoogleLogin.js